import Menu from "./menu";

export default function About() {
  return (
    <>
      <div className="col-12 col-md-12 col-xl-9">
        <div className="box-outer">
          <Menu />
          <div className="pb-0 pb-sm-2">
            <h1 className="title title--h1 title__separate">About Me</h1>
            <p>
            A highly motivated, result-oriented full-stack developer, willing to go an extra mile to reach goals
             and learn new knowledge.
            </p>
            <p>
            Over 8 years of experience in web and mobile development. Passionate about creating smart applications
             which can provide the best user experience and add the value to the product owner’s company. 
             Especially, over 4 years of experience in blockchain development: CEX and DEX trade, Swap, 
             4 types of tokens such as utility, payment, security and stable tokens, Defi tokens, 
             NFTs and asset-backed tokens and dapps.
            Good collaboration and communication with team members and clients.
            </p>
            <p>
            I am seeking actively a challenging position in a reputable software company.
            </p>
          </div>
          <h2 className="title title--h2 mt-3">What I'm Doing</h2>
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="case-item box box-inner">
                <div>
                  <h3 className="title title--h3">Blockchain Development</h3>
                  <p
                    className="case-item__caption"
                    data-toggle="modal"
                    data-target="#Blockchain"
                  >
                  I am specializing in building robust & intuitive blockchain products.
                  <br /> I focus on delivering exceptional User-Experience through
                  my Apps. Offering a full range of blockchain development services, I
                  offer the following: development of CEX and DEX trade, Swap, 
                  4 types of tokens...
                  </p>
                  <div className="case-item__stack">

                    <div className="tooltip">
                      <img src="assets/images/stackicons/ethereum_96.png" alt="solidity"/>
                      <span className="tooltiptext">Solidity</span>
                    </div>

                    <div className="tooltip">
                      <img src="assets/images/stackicons/rust.png" alt="rust"/>
                      <span className="tooltiptext">Rust</span>
                    </div>

                    <div className="tooltip">
                      <img src="assets/images/stackicons/go.png" alt="go"/>
                      <span className="tooltiptext">Go</span>
                    </div>

                    <div className="tooltip">
                      <img src="/assets/images/stackicons/react.png" alt="react" />
                      <span className="tooltiptext">React</span>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="case-item box box-inner">
                <div>
                  <h3 className="title title--h3">Mobile Development</h3>
                  <p
                    className="case-item__caption"
                    data-toggle="modal"
                    data-target="#Mobile"
                  >
                    I am provding smart mobile applications which can add lots of value to you.
                    My product which I can provide includes several kinds such as native iOS and android 
                    and hybrid mobile applications and serveral fields such as fitness, ecommerce, social ...
                  </p>
                  <div className="case-item__stack">
                    
                    <div className="tooltip">
                      <img src="/assets/images/stackicons/swift_96.png" alt="Swift" />
                      <span className="tooltiptext">Swift</span>
                    </div>

                    <div className="tooltip">
                      <img src="/assets/images/stackicons/kotlin_96.png" alt="Kotlin" />
                      <span className="tooltiptext">Kotlin</span>
                    </div>

                    <div className="tooltip">
                      <img src="/assets/images/stackicons/reactnative_96.png" alt="reactnative" />
                      <span className="tooltiptext">React Native</span>
                    </div>

                    <div className="tooltip">
                      <img src="assets/images/stackicons/nodejs.png" alt="nodejs" />
                      <span className="tooltiptext">NodeJs</span>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="case-item box box-inner">
                <div>
                  <h3 className="title title--h3">QA Testing</h3>
                  <p
                    className="case-item__caption"
                    data-toggle="modal"
                    data-target="#qatesting"
                  >
                    The main key to the success of any product is its quality. I
                    offer QA services for Web and Mobile applications, which
                    covers all the main stages of the project development,
                    starting from testing the requirements at the initial stage
                    of software development and ending with the final testing at
                    the stage of product release and its implementation.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="case-item box box-inner">
                <div>
                  <h3 className="title title--h3">Expertise</h3>
                  <p
                    className="case-item__caption"
                    data-toggle="modal"
                    data-target="#expertise"
                  >
                    I am able to conduct a full expertise of your idea and the
                    concept of your project at an early stage in order to
                    calculate and identify all the risks of the future
                    development. At this stage, I conduct a deep study of the
                    functionality and logic of the product so that my customer
                    has a complete understanding of all the nuances and details
                    of his application...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="Blockchain">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content case-item box box-inner">
            <h3 className="title title--h3">
              Blockchain Development{" "}
              <span type="button" className="close" data-dismiss="modal">
                &times;
              </span>
            </h3>

            <p className="case-item__caption">
              I am specializing in building robust & intuitive blockchain products.
              <br /> I focus on delivering exceptional User-Experience through
              my Apps. Offering a full range of blockchain development services, I
              offer the following: development of CEX and DEX trade, Swap, 
              4 types of tokens such as utility, payment, security and stable tokens, Defi tokens, 
              NFTs and asset-backed tokens and dapps such as marketplace, allowing you to make your products
              and services more competitive, software support and software
              maintenance services which provide you with the quick
              troubleshooting as it arise, software modernization and refinement
              services in accordance with your current requirements.
            </p>
            <h3 className="title title--h3">Technology stack</h3>
            <br />
            <div className="case-item__stack">

              <div className="tooltip">
                <img src="assets/images/stackicons/ethereum_96.png" alt="solidity"/>
                <span className="tooltiptext">Solidity</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/rust.png" alt="rust"/>
                <span className="tooltiptext">Rust</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/go.png" alt="go"/>
                <span className="tooltiptext">Go</span>
              </div>

              <div className="tooltip">
                <img src="/assets/images/stackicons/react.png" alt="react" />
                <span className="tooltiptext">React</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/vue.png" alt="vue" />
                <span className="tooltiptext">Vue</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/js.png"alt="javaScript"/>
                <span className="tooltiptext">JavaScript</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/ts.png"alt="typescript"/>
                <span className="tooltiptext">Typescript</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/nodejs.png" alt="nodejs" />
                <span className="tooltiptext">NodeJs</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/firebase.png" alt="firebase"/>
                <span className="tooltiptext">Firebase</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/aws.png" alt="aws" />
                <span className="tooltiptext">AWS</span>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="Mobile">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content case-item box box-inner">
            <h3 className="title title--h3">
              Mobile Development{" "}
              <span type="button" className="close" data-dismiss="modal">
                &times;
              </span>
            </h3>

            <p className="case-item__caption">
              I am provding smart mobile applications which can add lots of value to you.
              My product which I can provide includes several kinds such as native iOS and android 
              and hybrid mobile applications and serveral fields such as fitness, ecommerce, social 
              and tutoring mobile applications.
              The development of all our project involves and
              is based on the latest and most stable technologies.
            </p>
            <h3 className="title title--h3">Technology stack</h3>
            <br />
            <div className="case-item__stack">
              <div className="tooltip">
                <img src="/assets/images/stackicons/swift_96.png" alt="Swift" />
                <span className="tooltiptext">Swift</span>
              </div>

              <div className="tooltip">
                <img src="/assets/images/stackicons/kotlin_96.png" alt="Kotlin" />
                <span className="tooltiptext">Kotlin</span>
              </div>

              <div className="tooltip">
                <img src="/assets/images/stackicons/reactnative_96.png" alt="reactnative" />
                <span className="tooltiptext">React Native</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/nodejs.png" alt="nodejs" />
                <span className="tooltiptext">NodeJs</span>
              </div>

              <div className="tooltip">
                <img src="/assets/images/stackicons/flutter_96.png" alt="flutter" />
                <span className="tooltiptext">Flutter</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/aws.png" alt="aws" />
                <span className="tooltiptext">AWS</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/firebase.png" alt="firebase"/>
                <span className="tooltiptext">Firebase</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/mysql.png" alt="mysql" />
                <span className="tooltiptext">MySQL</span>
              </div>

              <div className="tooltip">
                <img src="assets/images/stackicons/mongodb.png" alt="mongodb" />
                <span className="tooltiptext">MongoDB</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="qatesting">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content case-item box box-inner">
            <h3 className="title title--h3">
              QA Testing{" "}
              <span type="button" className="close" data-dismiss="modal">
                &times;
              </span>
            </h3>

            <p className="case-item__caption">
              The main key to the success of any product is its quality.
              <br />
              I offer QA services for Web and Mobile applications, which covers
              all the main stages of the project development, starting from
              testing the requirements at the initial stage of software
              development and ending with the final testing at the stage of
              product release and its implementation.
              <br />
              <br />I gladly assist my clients with the following QA services:
              manual, load and automated testing, web and mobile testing ,
              functional testing, GUI and UX testing, acceptance testing,
              cross-browser testing, compatibility testing, integrational
              testing, layout testing, modal testing, API testing, regression
              testing and bugs verification, ad-hoc testing, and creating
              testing documentation.
            </p>
          </div>
        </div>
      </div>
      <div className="modal fade" id="expertise">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content case-item box box-inner">
            <h3 className="title title--h3">
              Expertise{" "}
              <span type="button" className="close" data-dismiss="modal">
                &times;
              </span>
            </h3>

            <p className="case-item__caption">
              I am able to conduct a full expertise of your idea and the concept
              of your project at an early stage in order to calculate and
              identify all the risks of the future development. At this stage, I
              conduct a deep study of the functionality and logic of the product
              so that my customer has a complete understanding of all the
              nuances and details of his application. In order to build an
              excellent development architecture and evaluate the whole project,
              I conduct the evaluation at all stages of the expertise, and only
              after the expertise has been completed and documented in the user
              story and mockups, I give the final evaluation and deadlines.
              <br /> <br />
              The plan is simple, but it’s still very important as it’s crucial
              to understand WHAT and HOW will be involved at each stage of
              development.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
